import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useApi } from "../../hooks/useApi";
import { toast } from "sonner";

export default function AdminJourneys() {
  const api = useApi();
  const qc = useQueryClient();
  const [active, setActive] = useState(null);
  const { data } = useQuery({ queryKey: ["admin-campaigns"], queryFn: async () => (await api.get("/admin/campaigns")).data });

  const campaign = data?.find((c) => c.id === active);
  const [draft, setDraft] = useState({});

  const save = async () => {
    await api.patch(`/admin/campaigns/${active}`, draft);
    toast.success("Journey saved");
    qc.invalidateQueries({ queryKey: ["admin-campaigns"] });
    setActive(null);
    setDraft({});
  };

  return (
    <div data-testid="admin-journeys-page">
      <h1 className="font-display text-display-xs mb-2">Content Journey Builder</h1>
      <p className="text-white/70 text-sm mb-6">Season 19 HXR slate — 9 governed campaign slots. Episode 778 is the proposed pilot.</p>
      <div className="space-y-3">
        {data?.map((c) => (
          <div key={c.id} data-testid={`admin-campaign-row-${c.id}`} className="bg-surface border border-border p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm">Slot {c.slot_number} — {c.name}</p>
                <p className="text-xs text-white/70">{c.status} {c.episode_ref ? `· pilot ep. ${c.episode_ref}` : ""}</p>
              </div>
              <button
                data-testid={`admin-campaign-edit-${c.id}`}
                onClick={() => { setActive(c.id); setDraft({ course1: c.course1, course2: c.course2, course3: c.course3, status: c.status }); }}
                className="text-xs uppercase text-brandAccent"
              >
                Edit
              </button>
            </div>
            {active === c.id && (
              <div className="mt-4 space-y-3">
                {["course1", "course2", "course3"].map((f, i) => (
                  <textarea
                    key={f}
                    data-testid={`admin-campaign-${f}-input`}
                    value={draft[f] || ""}
                    onChange={(e) => setDraft((d) => ({ ...d, [f]: e.target.value }))}
                    placeholder={`Course ${i + 1}`}
                    className="w-full bg-black border border-white/15 px-3 py-2 text-sm h-20"
                  />
                ))}
                <div className="flex gap-3 items-center">
                  <select data-testid="admin-campaign-status-select" value={draft.status} onChange={(e) => setDraft((d) => ({ ...d, status: e.target.value }))} className="bg-black border border-white/15 text-xs px-2 py-1">
                    <option value="draft">draft</option>
                    <option value="governed">governed (Director approved)</option>
                  </select>
                  <button data-testid="admin-campaign-save" onClick={save} className="bg-white text-black px-4 py-2 text-xs uppercase">Save</button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
